import { REFRESH_TOKEN } from '@/app/core';
import { SessionService } from '@/app/core/services/session.service';
import { UserSession } from '@/app/models/interface/user.session';
import { Component, inject, input, signal, viewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SessionModalComponent } from './components/session-modal/session-modal.component';

type ModalStep = 'verify' | 'sessions';

@Component({
  selector: 'c-user-session',
  standalone: false,
  templateUrl: './user-session.component.html',
  styleUrl: './user-session.component.css',
})
export class UserSessionComponent {
  private sessionService = inject(SessionService);

  dobleFactorActivado = input.required<boolean>();

  private cookie = inject(CookieService);
  async ngOnInit() {
    const refreshToken = this.cookie.get(REFRESH_TOKEN);

    const refreshTokenHash = await this.sha256(refreshToken);

    this.currentSessionId.set(refreshTokenHash);

    this.sessionService
      .findAll()
      .subscribe(({ sessions, activas, inactivas }) => {
        this.sessions.set(sessions);
        this.activeSessions.set(activas);
        this.revokedSessions.set(inactivas);
      });
  }

  sessions = signal<UserSession[]>([]);

  // Sesión actual, identificada por su ID.
  currentSessionId = signal<string | null>(null);

  step = signal<ModalStep>('sessions');

  activeSessions = signal<number>(0);

  revokedSessions = signal<number>(0);

  deviceIcon(type: UserSession['deviceType']): string {
    switch (type) {
      case 'mobile':
        return '▯';

      case 'tablet':
        return '▣';

      default:
        return '▰';
    }
  }

  private modal = viewChild<SessionModalComponent>('modal');

  revokeSession(refreshToken: string) {
    this.sessionService.revokeSession(refreshToken).subscribe({
      next: (data) => {
        const item = this.modal()
          ?.sessions()
          .find((i) => i.id === data.id);

        if (item) Object.assign(item, data);
      },
    });
  }

  private async sha256(value: string): Promise<string> {
    const data = new TextEncoder().encode(value);

    const hash = await globalThis.crypto.subtle.digest('SHA-256', data);

    return Array.from(new Uint8Array(hash))
      .map((byte) => byte.toString(16).padStart(2, '0'))
      .join('');
  }
}
